// extends
import { ArContainer, ArGraphics, ArSprite } from '@aceroll/core';

export class ProgressBar extends ArContainer {
	#mask = null;

	constructor(progressAsset) {
		super('progress-bar');
		this.createProgressBar(progressAsset);
	}

	createProgressBar(progressAsset) {
		const loaderFill = ArSprite.from(progressAsset);
		loaderFill.anchor.set(0.5, 0.5);

		this.#mask = new ArGraphics('progress-mask');
		this.#mask.rect(0, -loaderFill.height / 2, loaderFill.width, loaderFill.height);
		this.#mask.fill(0xffffff);
		this.#mask.scale.x = 0;
		this.#mask.position.set(loaderFill.x - loaderFill.width / 2, loaderFill.y);
		loaderFill.mask = this.#mask;
		this.addChild(loaderFill, this.#mask);
	}

	setProgress(progress) {
		const clampedProgress = Math.min(100, Math.max(0, progress));
		this.#mask.scale.x = clampedProgress / 100;
	}
}
